import BasePage from './base-page';
import MobileMenu from 'mmenu-light';

class Products extends BasePage {
    onReady() {
        let productsList = app.element('salla-products-list'),
            urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('sort')) {
            app.element('#product-filter').value = urlParams.get('sort');
        }
        app.on('change', '#product-filter', async event => {
            window.history.replaceState(null, null, salla.helpers.addParamToUrl('sort', event.currentTarget.value));
            productsList.sortBy = event.currentTarget.value;
            await productsList.reload();
            productsList.setAttribute('filters', `{"sort": "${event.currentTarget.value}"}`)
        });
        salla.event.once('salla-products-list::products.fetched', res => {
            res.title && (app.element('#page-main-title').innerHTML = res.title);
        });
        this.initiateMobileMenu()
        const toggles = document.querySelectorAll('.W__viewToggle');
        toggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                this.W__FormatCols(true, e.currentTarget);
            });
        });
    }
    W__FormatCols(isAdd, element) {
        if (window.innerWidth <= 768) return;
        const resultsDiv = document.querySelector('.s-products-list-filters-results') || document.querySelector('.s-products-list-vertical-cards');
        if (!resultsDiv) return console.error('No results container found!');
        const allToggles = document.querySelectorAll('.W__viewToggle');
        if (!allToggles.length) return console.error('No toggles found!');
        allToggles.forEach(toggle => {
            toggle.querySelectorAll('path').forEach(path => {
                path.setAttribute('fill', 'var(--color-title)');
            path.setAttribute('fill-opacity', '0.5');
            });
        });
        element.querySelectorAll('path').forEach(path => {
            path.setAttribute('fill-opacity', '1');
            
        });

        const columnsLayouts = {
            one: 'repeat(4, minmax(0, 1fr))',
            two: 'repeat(2, minmax(0, 1fr))',
            three: 'repeat(3, minmax(0, 1fr))'
        };

        resultsDiv.style.gridTemplateColumns = columnsLayouts[element.getAttribute('data')] || '1fr 1fr 1fr';
    }

initiateMobileMenu() {
    const filtersElement = app.element("#filters-menu");
    const trigger = app.element("a[href='#filters-menu']");
    const close = app.element("button.close-filters");
    if (!filtersElement || !trigger || !close) return;
    // window.shaoermenue is emitted by master.twig and may be "true"/"false"/"1"/"0"
    // depending on how the merchant setting is stored. Treat anything except an
    // explicit off-value as enabled.
    const v = window.shaoermenue;
    const showFiltersAlways = v != null && String(v).toLowerCase() !== 'false' && String(v) !== '0' && String(v) !== '';
    if (showFiltersAlways) {
        filtersElement.classList.remove('hidden');
        trigger.classList.remove('hidden');
    }

    const maxWidthscreen = showFiltersAlways ? "(max-width: 3024px)" : "(max-width: 1024px)";
    const mobileMenu = new MobileMenu(filtersElement, maxWidthscreen, { slidingSubmenus: false });
    const drawer = mobileMenu.offcanvas({
        position: salla.config.get('theme.is_rtl') ? "right" : "left"
    });

    trigger.addEventListener('click', event => {
        event.preventDefault();
        document.body.classList.add('filters-opened');
        drawer.open();
    });

    close.addEventListener('click', event => {
        event.preventDefault();
        document.body.classList.remove('filters-opened');
        drawer.close();
    });

    salla.event.on('salla-filters::changed', filters => {
        if (!Object.entries(filters).length) return;
        document.body.classList.remove('filters-opened');
        drawer.close();
    });
}


}

Products.initiateWhenReady([
    'product.index',
    'product.index.latest',
    'product.index.offers', 'product.index.search',
    'product.index.tag',
]);
